import React from "react";
import Banner from "../common/Banner";
import careerData from "../../data/career.json";
import images from "../../assets/images/Constant";
import { FiCheckCircle } from "react-icons/fi";

export default function CareerPage() {
  const hero = careerData?.hero || {};
  const features = careerData?.features || [];
  const positions = careerData?.positions || {};

  return (
    <>
      <Banner
        title={careerData?.banner?.title || "Career"}
        currentLabel={careerData?.banner?.breadcrumb || "Career"}
      />

      {/* HERO */}
      <section className="max-w-[1200px] mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-6">
            {/* <div className="flex items-center gap-3 text-primary font-semibold tracking-widest text-sm">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full border border-primary/30">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 1.3L10.7 6 6 10.7 1.3 6 6 1.3Z"
                    stroke="currentColor"
                    strokeWidth="1.2"
                  />
                </svg>
              </span>
              
              <span>{hero.eyebrow}</span>
            </div> */}
            <div className="flex gap-2 py-4 ">
  <img src={images[hero.icon]} alt=""  className=""/>
          <span className="text-base md:text-[22px] uppercase tracking-widest  font-medium text-primary">
            {hero.eyebrow}
          </span>
</div>

            <h2 className="mt-3 text-3xl md:text-[44px] leading-tight font-semibold text-[#0b2c3d]">
              {hero.leftTitle}
            </h2>
          </div>

          <div className="lg:col-span-6">
            <h3 className="text-xl md:text-2xl font-semibold text-[#0b2c3d]">
              {hero.rightTitle}
            </h3>
            <div className="mt-4 space-y-1 text-sm text-[#9CA3AF] leading-relaxed">
              {(hero.rightDescription || []).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        </div>

        {/* FEATURES GRID */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div
              key={`${f.title}-${i}`}
              className="bg-white border border-[#F1F1F1] p-7"
            >
              <div className=" text-primary ">
                {/* <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1 3-6Z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                  />
                </svg> */}

<FiCheckCircle className="text-3xl" />
              </div>

              <h4 className="mt-4 font-semibold text-[#0b2c3d]">{f.title}</h4>
              <p className="mt-2 text-sm text-[#9CA3AF] leading-relaxed">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* OPEN POSITIONS */}
      <section className="bg-[#FAFAFA] pt-16">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 mb-12 sm:mb-20">
          <div className="text-center">
            {/* <div className="flex items-center justify-center gap-3 text-primary font-semibold tracking-widest text-sm">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full border border-primary/30">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 1.3L10.7 6 6 10.7 1.3 6 6 1.3Z"
                    stroke="currentColor"
                    strokeWidth="1.2"
                  />
                </svg>
              </span>
              <span>{positions.eyebrow}</span> */}
              <div className="flex gap-2 py-4 justify-center items-center font-medium ">
  <img src={images[hero.icon]} alt=""  className=""/>
          <span className="text-base md:text-[22px] uppercase tracking-widest  text-primary">
            {positions.eyebrow}
          </span>
            </div>
            <h2 className="mt-4 text-3xl md:text-[40px] font-semibold text-[#0b2c3d]">
              {positions.title}
            </h2>
          </div>
          <div className="mt-10">
            <h2 className="mt-2 text-lg md:text-[20px] text-center font-semibold text-[#0b2c3d]">
              {positions.subTitle}
            </h2>
            <p className="mt-8 text-center text-lg md:text-[24px] font-normal text-primary ">
              {(positions.resumeEmails || []).map((email, i, arr) => (
                <React.Fragment key={email}>
                  <a href={`mailto:${email}`} className="hover:text-[#0b2c3d]">
                    {email}
                  </a>
                  {i < arr.length - 1 ? ", " : ""}
                </React.Fragment>
              ))}
            </p>
          </div>

          {/* <div className="mt-10 space-y-4">
            {items.map((job) => {
              const open = openId === job.id;
              return (
                <div key={job.id} className="bg-white border border-[#EDEDED]">
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : job.id)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left bg-[#F4F4F4]"
                    aria-expanded={open}
                  >
                    <div className="min-w-0">
                      <h3 className="font-semibold text-[#0b2c3d]">
                        {job.title}
                      </h3>
                      <div className="mt-2 flex flex-wrap gap-x-10 gap-y-2 text-xs text-[#6B7280]">
                        <span>
                          Type:{" "}
                          <span className="font-semibold text-[#0b2c3d]">
                            {job.type}
                          </span>
                        </span>
                        <span>
                          Place:{" "}
                          <span className="font-semibold text-[#0b2c3d]">
                            {job.place}
                          </span>
                        </span>
                        <span>
                          Salary:{" "}
                          <span className="font-semibold text-[#0b2c3d]">
                            {job.salary}
                          </span>
                        </span>
                      </div>
                    </div>

                    <Chevron open={open} />
                  </button>

                  {open && (
                    <div className="px-6 pb-6">
                      <div className="border-t border-[#EDEDED] pt-5">
                        <p className="text-sm text-[#9CA3AF] leading-relaxed">
                          {job.summary}
                        </p>

                        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-10">
                          <div>
                            <h4 className="font-semibold text-[#0b2c3d]">
                              Key Responsibilities
                            </h4>
                            <ul className="mt-3 space-y-2 text-sm text-[#6B7280] list-disc pl-5">
                              {(job.responsibilities || []).map((x, i) => (
                                <li key={i}>{x}</li>
                              ))}
                            </ul>

                            <h4 className="mt-6 font-semibold text-[#0b2c3d]">
                              What We Offer
                            </h4>
                            <ul className="mt-3 space-y-2 text-sm text-[#6B7280] list-disc pl-5">
                              {(job.offer || []).map((x, i) => (
                                <li key={i}>{x}</li>
                              ))}
                            </ul>
                          </div>

                          <div>
                            <h4 className="font-semibold text-[#0b2c3d]">
                              Qualifications & Skills
                            </h4>
                            <ul className="mt-3 space-y-2 text-sm text-[#6B7280] list-disc pl-5">
                              {(job.skills || []).map((x, i) => (
                                <li key={i}>{x}</li>
                              ))}
                            </ul>

                            <h4 className="mt-6 font-semibold text-[#0b2c3d]">
                              How to Apply
                            </h4>
                            <p className="mt-3 text-sm text-[#6B7280]">
                              {job.apply}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div> */}
        </div>
      </section>
    </>
  );
}

